import { createFileRoute } from '@tanstack/react-router';

import { AdminAdPopupsPage } from '@pages/admin';

export const Route = createFileRoute(
  '/$locale/_authenticated/admin/settings/business/communications-promotions/ad-popups'
)({ component: AdminAdPopups });

function AdminAdPopups() {
  return <AdminAdPopupsPage />;
}
